// extracted by mini-css-extract-plugin
module.exports = {"weekdays":"Weekdays_weekdays__3Vm06","day":"Weekdays_day__3pUNT"};